import { Modal, message } from 'antd';
import { Auth } from 'aws-amplify';
import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Button, Form, Grid, Icon, Loader, Dimmer, Popup } from 'semantic-ui-react';
import amex from '../../../images/amex.svg';
import mastercard from '../../../images/mastercard.svg';
import matejkaLogo from '../../../images/matejkaLogo.webp';
import stripe from '../../../images/stripe.webp';
import visa from '../../../images/visa.svg';
import avatar from '../../../images/avatar.svg';
import logo from '../../../images/logoWhite.png';
import logoLegalTechFactory from '../../../images/logoLegalTechFactory.webp';
import { LoginFormState } from '../../admin/pages/Interfaces';
import UserRegistrationForm from '../../frontoffice/components/UserRegistrationForm';
import PasswordResetForm from './PasswordResetForm';
import { UnorderedListOutlined } from '@ant-design/icons';
import { translations } from '../../../utils/LocalizedStrings';
import { AssignOrderAction, SetRecentlyConfirmed, SetRecentlyConfirmed as setRecentlyConfirmed } from '../../../app/ActionsImpl';
import { LANDING_PAGE_URI } from '../../../constants';

const LoginModal = ({
  visible,
  handleClose,
  user,
  setRecentlyConfirmed
}) => {
  const [formState, setFormState] = useState(LoginFormState.LOGIN)
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [verificationCode, setVerificationCode] = useState(false);
  const [returnedUser, setReturnedUser] = useState();

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setEmail("")
    setPassword("")
    setVerificationCode("")
    setReturnedUser()
    setFormState(LoginFormState.LOGIN)
  }, [visible])

  useEffect(() => {
    setEmail("")
    setPassword("")
    setVerificationCode("")
    setReturnedUser()
  }, [visible])

  async function signIn() {
    setIsLoading(true)
    try {
      let shouldClose = true;
      const user = await Auth.signIn(email, password);
      if (user.challengeName === "SMS_MFA") {
        setFormState(LoginFormState.SMS_MFA)
        setReturnedUser(user)
        shouldClose = false;
      }
      if (returnedUser) {
        message.info("Overovacia SMS bola odoslaná")
        shouldClose = false;
      }
      if (shouldClose) {
        handleClose();
      }
    } catch (error) {
      console.log(error)
      if (error.code === "UserNotConfirmedException") {
        setFormState(LoginFormState.USER_NOT_VERIFIED);
      } else {
        message.error("Prihlásenie sa nepodarilo")
      }
    }
    setIsLoading(false)
  }

  async function signOut() {
    setIsLoading(true)
    try {
      const user = await Auth.signOut();
      setFormState(LoginFormState.LOGIN)
    } catch (error) {
      message.error(error)
    }
    setIsLoading(false)
  }

  async function confirmSignup() {
    setIsLoading(true)
    try {
      await Auth.confirmSignUp(email, verificationCode);
      setFormState(LoginFormState.LOGIN)
      setRecentlyConfirmed(true)
    } catch (error) {
      message.error('Registrácia sa nepodarila')
    }
    setIsLoading(false)
  }

  async function confirmSignIn() {
    setIsLoading(true)
    try {
      await Auth.confirmSignIn(returnedUser, verificationCode, returnedUser.challengeName);
      handleClose();
      setFormState(LoginFormState.LOGGED_IN);
    } catch (error) {
      message.error('Zadali ste nesprávny kód.');
    }
    setIsLoading(false)
  }

  async function forgotPassword() {
    setIsLoading(true)
    try {
      await Auth.forgotPassword(email)
      setFormState(LoginFormState.PASSWORD_RESET);
    } catch (error) {
      message.error('Zadali ste nesprávny kód.');
    }
    setIsLoading(false)
  }

  async function resendConfirmationCode() {
    setIsLoading(true)
    try {
      await Auth.resendSignUp(email);
      message.info("Overovací kód bol odoslaný.")
    } catch (err) {
      message.error(err.message)
    }
    setIsLoading(false)
  }

  return (
    <Modal
      centered
      visible={visible}
      onCancel={handleClose}
      onOk={() => {
        handleClose();
      }}
      className={!user ? 'loginModal' : 'userStatusModal'}
      maskStyle={{ padding: 0 }}
      style={{ margin: 0 }}
      footer={null}
      dimmer="blurring">
      {
        isLoading && <Dimmer active>
          <Loader size='large' inverted>{translations.artifacts.LoginModalBox.loading}</Loader>
        </Dimmer>
      }
      {!user &&
        <div className="orderForm">
          {formState === LoginFormState.LOGIN &&
            <main id="login">
              <div id='mainWrapper'>
                <a onClick={() => { window.location = LANDING_PAGE_URI }} className="login-logo">
                  <img
                    src={logo}
                    alt="MOJEZMLUVY.SK"
                  />
                </a>
                <div className="loginBox">
                  <header className='loginHeader'>{translations.artifacts.LoginModalBox.loginRegister}</header>
                  <Form>
                    <Form.Field className="contactField">
                      <div className='loginInputField'>
                        <Icon name="user" />
                        <Form.Input
                          id={'emailInputCheckoutForm'}
                          label="Váš e-mail"
                          name="kontakt_email"
                          value={email}
                          onChange={(e) => {
                            setEmail(e.target.value);
                          }}
                        />
                      </div>
                      <div className='loginInputField'>
                        <Icon name="lock" />
                        <Form.Input
                          id={'emailInputCheckoutForm'}
                          label="Heslo"
                          type='password'
                          name="password"
                          value={password}
                          onKeyDown={(e) => e.keyCode === 13 && signIn(e)}
                          onChange={(e) => {
                            setPassword(e.target.value);
                          }}
                        />
                      </div>
                    </Form.Field>
                  </Form>
                  <Form onSubmit={signIn} className="orderUiForm signInButton">
                    <Button
                      disabled={!email || !password}
                      className="ui primary big button"
                      type="submit">
                      {translations.artifacts.LoginModalBox.login}
                    </Button>
                  </Form>
                  <Form onSubmit={() => { setFormState(LoginFormState.REGISTER) }} className="orderUiForm register">
                    <Button
                      className="ui primary big button"
                      type="submit">
                      {translations.artifacts.LoginModalBox.register}
                    </Button>
                  </Form>
                  <Form onSubmit={() => { setFormState(LoginFormState.FORGOT_PASSWORD) }} className="orderUiForm register">
                    <Button
                      className="ui primary big button"
                      type="submit">
                      {translations.artifacts.LoginModalBox.forgot}
                    </Button>
                  </Form>
                </div>
              </div>
              <footer style={{ width: '100%' }}>
                <article className="footerSupport">
                  <h5 className="footerTitle">{translations.artifacts.LoginModalBox.operator}</h5>
                  <div id='footerLogosContainer'>
                    <a href="https://matejka.company" target='_blank'>
                      <img
                        className="footerLogo"
                        src={matejkaLogo}
                        alt="Matejka & Friedmannová"
                      />
                    </a>
                    <a href="https://www.legaltechfactory.eu/" target='_blank' aria-label='Legal Tech Factory Europe website'>
                    <img
                        className="legal-tech-logo"
                        src={logoLegalTechFactory}
                        alt="Legal Tech Factory Europe"
                      />
                    </a>
                  </div>
                </article>
                <article className="footer" id="footerPayment">
                  <ul className="socialMediaLinks paymentInfo" style={{ width: 'auto' }}>
                    <li className="banksCardsTitle" style={{ whiteSpace: 'pre' }}>
                      <p >{translations.artifacts.LoginModalBox.youCanPayWith}</p>
                    </li>
                    <li style={{ display: 'flex' }}>
                      <img src={visa} className="footerBankIcon" alt='visa' />
                    </li>
                    <li style={{ display: 'flex' }}>
                      <img src={mastercard} className="footerBankIcon" alt='mastercard' />
                    </li>
                    <li style={{ display: 'flex' }}>
                      <img src={amex} className="footerBankIcon" alt='amex' />
                    </li>
                    <li style={{ display: 'flex', marginLeft: -15 }}>
                      <img src={stripe} className="footerBankIconStripe" alt='stripe' />
                    </li>
                  </ul>
                  <ul className="socialMediaLinks" style={{ marginRight: 20 }}>
                    <li>
                      <a href="https://www.facebook.com/ORSR.HELP/" target="_blank">
                        <i className="facebook square icon" aria-hidden="true"></i>
                      </a>
                    </li>
                    <li>
                      <a href="https://www.linkedin.com/company/orsr-help/" target="_blank">
                        <i className="linkedin square icon" aria-hidden="true"></i>
                      </a>
                    </li>
                    <li>
                      <a href="https://www.instagram.com/orsr_help/" target="_blank">
                        <i className="instagram square icon" aria-hidden="true"></i>
                      </a>
                    </li>
                  </ul>
                </article>
                <article className="footer redirectLinks">
                  <p>&copy; MOJEZMLUVY.SK {new Date().getFullYear()}</p>
                  <nav>
                    <ul>
                      <li>
                        <a href="https://orsr.help/vseobecne-obchodne-podmienky" target="_blank">{translations.artifacts.LoginModalBox.rules}</a>
                      </li>
                      <li>
                        <a href="https://www.matejka.company/docs/kodex%20GDPR%20sk_en.pdf.pdf" target="_blank">{translations.artifacts.LoginModalBox.gdpr}</a>
                      </li>
                    </ul>
                  </nav>
                </article>
              </footer>
            </main>
          }
          {formState === LoginFormState.REGISTER &&
            <UserRegistrationForm
              setFormState={setFormState}
              setIsLoading={setIsLoading} />
          }
          {formState === LoginFormState.PASSWORD_RESET &&
            <PasswordResetForm
              setFormState={setFormState}
              setIsLoading={setIsLoading}
              email={email}
            />
          }
          {formState === LoginFormState.USER_NOT_VERIFIED &&
            <div className='loginModalSMS'>
              <h3>
                {translations.artifacts.LoginModalBox.emailControll}
              </h3>
              <Form.Field className="contactField">
                <Form.Input
                  id={'emailInputCheckoutForm'}
                  label={translations.artifacts.LoginModalBox.controlCode}
                  name="verification-code"
                  value={verificationCode}
                  onChange={(e) => {
                    setVerificationCode(e.target.value);
                  }}
                />
              </Form.Field>
              <Form onSubmit={confirmSignup} className="orderUiForm">
                <Button
                  disabled={!email || !verificationCode}
                  className="ui primary big button"
                  type="submit">
                  {translations.artifacts.LoginModalBox.controll}
                </Button>
              </Form>
              <h4>
                {translations.artifacts.LoginModalBox.resendEmail}
              </h4>
              <Form onSubmit={resendConfirmationCode} className="orderUiForm">
                <Button
                  className="ui primary big button"
                  type="submit">
                  {translations.artifacts.LoginModalBox.resend}
                </Button>
              </Form>
            </div>
          }
          {formState === LoginFormState.FORGOT_PASSWORD &&
            <main id="login">
              <div id='mainWrapper'>
                <div className="loginBox">
                  <span className='stepBackArrow' onClick={() => setFormState(LoginFormState.LOGIN)}>
                    <Popup className='stepBackArrowPopup' content='Krok späť' trigger={<Icon name="arrow left" />} />
                  </span>
                  <header className='loginHeader'>{translations.artifacts.LoginModalBox.forNewPass} <br />{translations.artifacts.LoginModalBox.youUsed}</header>
                  <Form className='forgotPassword'>
                    <Form.Field className="contactField">
                      <div className='loginInputField'>
                        <Form.Input
                          id={'emailInputCheckoutForm'}
                          label={translations.artifacts.LoginModalBox.yourMail}
                          name="kontakt_email"
                          required
                          value={email}
                          onKeyDown={(e) => e.keyCode === 13 && forgotPassword(e)}
                          onChange={(e) => {
                            setEmail(e.target.value);
                          }}
                        />
                      </div>
                    </Form.Field>
                  </Form>
                  <Form onSubmit={forgotPassword} className="orderUiForm">
                    <Button
                      disabled={!email}
                      className="ui primary big button"
                      type="submit">
                      {translations.artifacts.LoginModalBox.sendCode}
                    </Button>
                  </Form>
                </div>
              </div>

            </main>
          }
          {formState === LoginFormState.SMS_MFA &&
            <div className='loginModalSMS'>
              <h3>{translations.artifacts.LoginModalBox.codeSms}</h3>
              <Form.Field className="contactField">
                <Form.Input
                  id={'emailInputCheckoutForm'}
                  label={translations.artifacts.LoginModalBox.controlCode}
                  name="verification-code"
                  value={verificationCode}
                  onKeyDown={(e) => e.keyCode === 13 && confirmSignIn(e)}
                  onChange={(e) => {
                    setVerificationCode(e.target.value);
                  }}
                />
              </Form.Field>
              <Form onSubmit={confirmSignIn} className="orderUiForm">
                <Button
                  disabled={!email || !verificationCode}
                  className="ui primary big button"
                  type="submit">
                  {translations.artifacts.LoginModalBox.controll}
                </Button>
              </Form>
              <h4>
                {translations.artifacts.LoginModalBox.resendSms}
              </h4>
              <Form onSubmit={signIn} className="orderUiForm">
                <Button
                  className="ui primary big button"
                  type="submit">
                  {translations.artifacts.LoginModalBox.reControl}
                </Button>
              </Form>
            </div>
          }
        </div>
      }
      {user &&
        <div>
          <Form className="orderUiForm userStatusModalWindow">
            <div className='userStatusRow'>
              <div><img class="avatarLogo" src={avatar} alt="user avatar" width="100" /></div>
              <div>
                <div className='userName'>{user.attributes.given_name} {user.attributes.family_name}</div>
                <div className='userEmail'>{user.attributes.email}</div>
              </div>
            </div>
            <Button className='myOrders' onClick={() => (window.location = '/user-profile')}>
              <UnorderedListOutlined />{translations.artifacts.LoginModalBox.myOrders}</Button>
          </Form>
          <Form onSubmit={signOut} className="orderUiForm userStatusModalWindow">
            <Button
              className="logoutButton"
              type="submit">
              <Icon name="log out" />
              {translations.artifacts.LoginModalBox.logOut}
            </Button>
          </Form>
        </div>
      }
    </Modal >
  );
};

const mapStateToProps = ({ appState }) => ({
  user: appState.cognitoUser,
  recentlyConfirmed: appState.recentlyConfirmed
});

const mapDispatchToProps = {
  setRecentlyConfirmed: SetRecentlyConfirmed
}
export default connect(mapStateToProps, mapDispatchToProps)(LoginModal)